(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cp-nav__dropdown, .cp-language-picker').forEach(function (dropdown) {
    var closeTimer;
    var desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    dropdown.addEventListener('mouseenter', function () {
      if (!desktopPointer.matches) return;
      window.clearTimeout(closeTimer);
      dropdown.open = true;
    });

    dropdown.addEventListener('mouseleave', function () {
      if (!desktopPointer.matches) return;
      closeTimer = window.setTimeout(function () {
        dropdown.open = false;
      }, 120);
    });

    dropdown.addEventListener('focusout', function (event) {
      if (!dropdown.contains(event.relatedTarget)) dropdown.open = false;
    });
  });

  document.querySelectorAll('.cp-age-form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      window.location.href = form.elements.age_url.value;
    });
  });

  /* Keep Koni covers at their full proportional width, without changing height or the shelf gap. */
  document.querySelectorAll('.cp-shelf').forEach(function (shelf) {
    var heading = shelf.querySelector('h2');
    if (!heading || heading.textContent.trim() !== 'საბავშვო წიგნები') return;
    shelf.classList.add('cp-shelf--kids');
    shelf.querySelectorAll('.cp-card__image img').forEach(function (image) {
      function sizeKoniCover() {
        if (!image.naturalWidth || !image.naturalHeight) return;
        var height = image.parentElement.getBoundingClientRect().height;
        var width = Math.round((image.naturalWidth / image.naturalHeight) * height);
        image.closest('.cp-card').style.setProperty('--cp-koni-cover-width', width + 'px');
      }
      if (image.complete) sizeKoniCover();
      image.addEventListener('load', sizeKoniCover);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
